import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { sanitizeHtmlKeepingStyles } from '../shared/safe-html/styled-html';
/**
 * Sanitises HTML that came from the server before it is bound to [innerHTML].
 *
 * This used to call bypassSecurityTrustHtml() on the raw value, which tells Angular to trust it and skips
 * all sanitisation, so a script or event handler stored in the content ran for every viewer (stored XSS).
 *
 * It now runs Angular's own sanitiser (SecurityContext.HTML), which drops scripts, event handler
 * attributes, javascript: URLs and iframes, and then puts back inline styles from a strict property
 * allow-list (colour, alignment, font weight, style and size, text decoration, simple borders, padding,
 * width and non-negative margins). See sanitizeHtmlKeepingStyles(): only values it validated are
 * restored, and raw input is never trusted. The sc-mobile pipe keeps the same style allow-list.
 * Embedded video iframes are not rendered by this pipe. Induction content that needs them uses
 * <app-safe-rich-content>, which re-creates iframes only for allow listed video hosts.
 */
@Pipe({
    name: 'sanitizeHtml',
    standalone: false
})
export class SanitizeHtmlPipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer
  ) { }
  transform(value: any, args?: any): SafeHtml {
    return sanitizeHtmlKeepingStyles(this.sanitizer, value);
  }
}
